import { configureStore } from '@reduxjs/toolkit';
// import rootReducer from './rootReducer';
import authReducer from '../modules/Auth/authSlice';
import blogsReducer from '../modules/Blog/blogSlice';
import locationsReducer from '../modules/Pages/locationSlice';
import marketAreasReducer from '../modules/MarketArea/marketAreaSlice';
import galleriesReducer from '../modules/Gallery/gallerySlice';
import settingsReducer from '../modules//Settings/settingSlice';
import categoriesReducer from '../modules/Category/categorySlice';
import childCategoriesReducer from '../modules/ChildCategory/childCategorySlice';
// import subCategoriesReducer from '../modules/SubCategory/SubCategorySlice';
import testimonialsReducer from '../modules/Testimonial/testimonialSlice';
import partnersReducer from '../modules/Partner/partnerSlice';
import teamsReducer from '../modules/Team/teamSlice';
import inquiriesReducer from '../modules/Inquiry/inquirySlice';
import productsReducer from '../modules/Product/productSlice';
import subCategoryProductsReducer from '../modules/SubCategoryProduct/subCategoryProductSlice';
import dashboardReducer from '../modules/Dashboard/dashboardSlice';
import organizationReducer from '../modules/Organization/organizationSlice';
import templateReducer from '../modules/Template/templateSlice';
import businessTypeReducer from '../modules/BusinessType/businessTypeSlice';
import organizationTypeReducer from '../modules/OrganizationType/organizationTypeSlice';
import legalFirmReducer from '../modules/LegalFirm/legalFirmSlice';
import countryReducer from '../modules/Country/countrySlice';
import stateReducer from '../modules/State/stateSlice';
import cityReducer from '../modules/City/citySlice';
import pagesReducer from '../modules/Page/pageSlice';
import galleryCategoryReducer from '../modules/GalleryCategory/galleryCategorySlice'; 
import faqReducer from '../modules/FrequentlyAskedQuestion/faqSlice';
import colorReducer from '../modules/ThemeConfiguration/colorSlice';


import homePageReducer from '../modules/Pages/HomePage/homePageSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    templates: templateReducer,
    organizations: organizationReducer,
    businessTypes: businessTypeReducer,
    organizationTypes: organizationTypeReducer,
    legalFirms: legalFirmReducer,
    countries: countryReducer,
    states: stateReducer,
    cities: cityReducer,
    categories: categoriesReducer,
    childCategories: childCategoriesReducer,
    blogs: blogsReducer,
    locations: locationsReducer,
    marketAreas: marketAreasReducer,
    galleries: galleriesReducer,
    pages: pagesReducer,
    // subcategories: subCategoriesReducer,
    testimonials: testimonialsReducer,
    partners: partnersReducer,
    teams: teamsReducer,
    inquiries: inquiriesReducer,
    products: productsReducer,
    subCategoryProducts: subCategoryProductsReducer,
    settings: settingsReducer,
    dashboard: dashboardReducer,
    homePage: homePageReducer,
    galleryCategory: galleryCategoryReducer,
    faqs: faqReducer,
    colors: colorReducer,
  },
  // auth: authReducer,
  // reducer: rootReducer,
  
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),

//   devTools: process.env.NODE_ENV !== 'production',  // Enables Redux DevTools in development
//   // You can also add middleware here if needed
});

export default store;